import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IApiResponse, Locations, Performance } from 'county-api';
import moment from 'moment';
import { Moment } from 'moment';
import { PerformanceDataService } from 'src/app/dashboard/perfomance/performance-data.service';
import { NotificationsService } from 'src/app/universal/notifications/notifications.service';

export interface IRevenueDialogData {
    lastUploadDate: Moment;
}

export enum RevenueDialogResultType {
    Upload = 5,
    Targets = 10,
}

export interface IRevenueDialogResult {
    type: RevenueDialogResultType;

    targets?: Performance.IPerformanceTarget[];

    date?: Moment;

    files?: File[];
}

@Component({
    selector: 'revenue-dialog',
    templateUrl: './revenue-dialog.component.html',
    styleUrls: ['./revenue-dialog.component.scss'],
})
export class RevenueDialogComponent implements OnInit {
    /**
     * The switch case to load the component.
     */
    step: number = 0;

    greatMultiplier: number = 0;
    goodMultiplier: number = 0;


    /**
     * Constructor to set pricate variables and load dependencies.
     * @param dialogRef The dialogs functionality.
     */
    constructor(
        private performanceService: PerformanceDataService,
        private notificationsService: NotificationsService,
        public dialogRef: MatDialogRef<
            RevenueDialogComponent,
            IRevenueDialogResult
        >,
        @Inject(MAT_DIALOG_DATA) public data: IRevenueDialogData,
    ) {}

    changeStep(step: number) {
        this.step = step;
    }

    ngOnInit() {
            this.performanceService.getPerformanceTarget(
                moment().startOf('month').format('YYYY-MM'),
            )
            .subscribe(data => {
                this.formatTargetData(data);
            });
    }

    formatTargetData(
        data: IApiResponse<Performance.IPerformanceTargetsViewModel>,
    ) {
        this.goodMultiplier = data.result.good_multiplier;
        this.greatMultiplier = data.result.great_multiplier;
    }

    updateMultipliers(){
        this.performanceService.setPerformanceSettings(this.goodMultiplier, this.greatMultiplier).subscribe(
            response => {
                this.notificationsService.success(
                    'Multipliers updated successfully.',
                );
            },
            er => {
                this.notificationsService.error(
                    'There was an error updating the multipliers.',
                );
            },
        );
    }

    submit(data: IRevenueDialogResult) {
        this.dialogRef.close(data);
    }
}
